var map = {
	"./ei_transfers_icon.svg": 1064,
	"./mainNavigationChevron_icon.svg": 1065,
	"./schedule_icon.svg": 1066,
	"./sports-news_icon.svg": 1067,
	"./sports_icon.svg": 1068,
	"./table_icon.svg": 1069,
	"./transfers_icon.svg": 1070,
	"./worldnews_icon.svg": 1071
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1285;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1285
// module chunks = 15